export default function BadgeShop() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-slate-900 to-slate-950 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-2">徽章商店</h1>
        <p className="text-slate-400 mb-8">用积分兑换独特的成就徽章</p>
        <div className="bg-slate-800/50 rounded-2xl p-12 border border-slate-700 text-center">
          <div className="text-6xl mb-4">🏅</div>
          <h2 className="text-2xl font-semibold text-white mb-2">徽章商店即将上线</h2>
          <p className="text-slate-400">完成更多任务赚取积分，解锁专属徽章</p>
        </div>
      </div>
    </div>
  );
}
